import { createUserManager } from 'redux-oidc';

const authority = process.env.REACT_APP_LOGIN_AUTHORITY;
const userManagerConfig = {
  authority,
  client_id: "snswivrweb.spa",
  response_type: "code",
  scope: "openid profile snswivrweb.api",
  redirect_uri: process.env.REACT_APP_LOGIN_REDIRECT,
  post_logout_redirect_uri: process.env.REACT_APP_LOGOUT_REDIRECT,
  automaticSilentRenew: true
};
const userManager = createUserManager(userManagerConfig);

export default userManager;
